export default {
  state: {
    user: 'zxy---'
  }
}